export default "__VITE_ASSET__HsGQRf3V__"